import { useMutation } from '@tanstack/react-query'

import { Methods } from '@/api/v1/change-password'
import { aspidaClient } from '@/lib/aspida'
import { MutationConfig } from '@/lib/react-query'

export type ChangePasswordDTO = {
  data: Methods['put']['reqBody']
}

export const changePassword = ({ data }: ChangePasswordDTO) => {
  return aspidaClient.v1.change_password.$put({ body: data })
}

type UseChangePasswordOptions = {
  config?: MutationConfig<typeof changePassword>
}

export const useChangePassword = ({ config }: UseChangePasswordOptions) => {
  return useMutation({
    ...config,
    mutationFn: changePassword,
  })
}
